import React from 'react'
import { useTranslation } from 'react-i18next';

const LocationInput = ({ value, placeholder, color, onClick, onClear }) => {
    const { t } = useTranslation();
    return (
        <div className="w-full bg-gray-100 border border-gray-100 px-[10px] flex items-center gap-2 rounded-[8px] focus-within:border-2 focus-within:border-[--bg-color]">

            <div className={color}></div>

            <input
                readOnly
                value={value || ""}
                placeholder={t(placeholder)}
                onClick={onClick}
                className="w-full py-3 outline-none text-[17px] bg-transparent"
            />

            {(value && placeholder !== "Stop location") && (
                <button onClick={onClear}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className="text-gray-200" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor" />
                        <path d="M13.061 12L15.531 9.53005C15.824 9.23705 15.824 8.76202 15.531 8.46902C15.238 8.17602 14.763 8.17602 14.47 8.46902L12 10.939L9.52999 8.46902C9.23699 8.17602 8.76199 8.17602 8.46899 8.46902C8.17599 8.76202 8.17599 9.23705 8.46899 9.53005L10.939 12L8.46899 14.47C8.17599 14.763 8.17599 15.238 8.46899 15.531C8.61499 15.677 8.80699 15.751 8.99899 15.751C9.19099 15.751 9.38298 15.678 9.52898 15.531L11.999 13.061L14.469 15.531C14.615 15.677 14.807 15.751 14.999 15.751C15.191 15.751 15.383 15.678 15.529 15.531C15.822 15.238 15.822 14.763 15.529 14.47L13.061 12Z" fill="currentColor" />
                    </svg>
                </button>
            )}
        </div>
    )
}

export default LocationInput